module.exports = __webpack_public_path__ + "img/moon_sun_icon.0ec38f89.svg";